import {
  ONBOARDING_SET_FILTERS,
  ONBOARDING_CLEAR_FILTERS,
  ONBOARDING_SET_PAGE,
  ONBOARDING_SET_PAGE_SIZE,
  ONBOARDING_SET_SEARCH,
  ONBOARDING_SET_SORT,
  ONBOARDING_FETCH_REQUEST,
  ONBOARDING_FETCH_SUCCESS,
  ONBOARDING_FETCH_FAILURE,
} from '../actions/actionTypes';
import { OnboardingAction } from '../actions/onboardingActions';
import { FiltersState, EMPTY_FILTERS } from '../../Talent/components/FiltersDrawer';
import { RawTalentRow } from '../../Talent/transformers/talentTransformer';

export interface OnboardingState {
  filters: FiltersState;
  search: string;
  sort: { column: string; direction: string } | null;
  data: RawTalentRow[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
  loading: boolean;
  error: string | null;
}

const initialState: OnboardingState = {
  filters: EMPTY_FILTERS,
  search: '',
  sort: null,
  data: [],
  pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 },
  loading: false,
  error: null,
};

export default function onboardingReducer(
  state: OnboardingState = initialState,
  action: OnboardingAction,
): OnboardingState {
  switch (action.type) {
    case ONBOARDING_SET_FILTERS:
      return { ...state, filters: action.payload, pagination: { ...state.pagination, page: 1 } };
    case ONBOARDING_CLEAR_FILTERS:
      return { ...state, filters: EMPTY_FILTERS, pagination: { ...state.pagination, page: 1 } };
    case ONBOARDING_SET_SEARCH:
      return { ...state, search: action.payload, pagination: { ...state.pagination, page: 1 } };
    case ONBOARDING_SET_SORT:
      return { ...state, sort: action.payload, pagination: { ...state.pagination, page: 1 } };
    case ONBOARDING_SET_PAGE:
      return { ...state, pagination: { ...state.pagination, page: action.payload } };
    case ONBOARDING_SET_PAGE_SIZE:
      return { ...state, pagination: { ...state.pagination, pageSize: action.payload, page: 1 } };
    case ONBOARDING_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case ONBOARDING_FETCH_SUCCESS:
      return { ...state, loading: false, data: action.payload.data, pagination: action.payload.pagination };
    case ONBOARDING_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
